// createOffsetLine.js
import * as THREE from 'three';

export const createOffsetLine = (baseLine, referencePoint, offsetDistance, options = {}) => {
    const { color = 0xff00ff, dashed = false } = options;

    const positions = baseLine.geometry.attributes.position.array;
    const start = new THREE.Vector3(positions[0], positions[1], positions[2]);
    const end = new THREE.Vector3(positions[3], positions[4], positions[5]);

    // Offset yönünü belirle
    const dir = new THREE.Vector3().subVectors(end, start).normalize();
    const normal = new THREE.Vector3(-dir.y, dir.x, 0);

    // ReferencePoint'e göre offset yönünü seç
    const toRef = new THREE.Vector3().subVectors(referencePoint, start);
    const dot = toRef.dot(normal);
    if (dot < 0) normal.negate();

    const offsetStart = start.clone().add(normal.clone().multiplyScalar(offsetDistance));
    const offsetEnd = end.clone().add(normal.clone().multiplyScalar(offsetDistance));

    // Geometri oluştur
    const geometry = new THREE.BufferGeometry().setFromPoints([offsetStart, offsetEnd]);

    // Malzeme seçimi
    let material;
    if (dashed) {
        material = new THREE.LineDashedMaterial({
            color,
            dashSize: 5,
            gapSize: 5
        });
    } else {
        material = new THREE.LineBasicMaterial({ color });
    }

    const offsetLine = new THREE.Line(geometry, material);

    // Eğer kesikli ise computeLineDistances çağır
    if (dashed) {
        offsetLine.computeLineDistances();
    }

    return offsetLine;
};
